import { CHANNEL_REQUIREMENTS, DEFAULT_LOGO_HEIGHT, DEFAULT_LOGO_WIDTH, PARTNER_WEBSITE } from '~/constants';
import { MarketplaceChannel, MarketplacePartner } from '~/types/marketplace';

type LogoProps = {
  partner?: MarketplacePartner;
  channel: MarketplaceChannel | null;
  type?: 'default' | 'minimal';
  width?: number;
};

export const Logo = ({ partner, channel, type = 'default', width }: LogoProps) => {
  const channelConfig = channel ? CHANNEL_REQUIREMENTS[channel] : null;
  const channelLogo = type === 'default' ? channelConfig?.logo.default : (channelConfig?.logo.minimal ?? channelConfig?.logo.default);

  if (!channelLogo) {
    return null;
  }

  return (
    <a target="_blank" rel="noreferrer" href={PARTNER_WEBSITE(partner)}>
      <img
        src={channelLogo}
        alt={`${channel} logo`}
        height={DEFAULT_LOGO_HEIGHT}
        width={width ?? channelConfig?.logoWidth ?? DEFAULT_LOGO_WIDTH}
      />
    </a>
  );
};
